export default ($axios, pubId) => (resource) => ({
  getAkamaiData(getMock) {
    const url = `/construct/getUserData`
    const mockedResponse = { userCountryCode: 'ES', userContinentCode: 'EU' }
    if (!getMock) {
      return $axios.get(url).then((result) => {
        window.geoIpData = result.data
        return result.data
      })
    } else {
      return mockedResponse
    }
  },
  resetPassword(payload) {
    const url = `/sso-api/reset-password`
    return $axios.post(url, payload).then((result) => result.data)
  },
  addMissingBooking(reservationId) {
    const domain = this.getDomain()
    const url = `${domain}/booking-management/addMissingBooking`
    const pload = { reservationId }

    return $axios.put(url, pload).then((result) => result.data)
  },
  getUserProfile() {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/member/getProfile/${pubId}`
    return $axios.get(url).then((result) => result.data)
  },
  getUpcomingBookings(offSet) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/getMyBookings/${pubId}?offSet=${offSet}&rowCount=3`
    return $axios.get(url).then((result) => result.data)
  },
  getAllUpcomingHotelBookings() {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/getMyBookings/${pubId}`
    /*  const url = 'https://run.mocky.io/v3/71622914-096d-4b3a-abf3-4329033525ba' */
    return $axios.get(url).then((result) => result.data)
  },
  getAllLiveLocalBookings(ghaId) {
    const domain = this.getDomain()
    const url = `${domain}/livelocal-api/memberExperiencesOffers/${ghaId}`
    return $axios.get(url).then((result) => result.data)
  },
  getPastBookings(offSet) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/getPastBookings/${pubId}?offSet=${offSet}&rowCount=3`
    return $axios.get(url).then((result) => result.data)
  },
  getAllPastHotelBookings(offSet) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/getPastBookings/${pubId}`
    return $axios.get(url).then((result) => result.data)
  },
  getAllPromotionsBooked() {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/offers/myOffers`
    return $axios.get(url).then((result) => result.data)
  },
  getUserRecentActivity(memberId) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/membershipTransactions/transactions/${memberId}`
    return $axios.get(url).then((result) => result.data)
  },
  getPointsExpiration(memberId) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/membershipTransactions/pointExpirations/${memberId}`
    return $axios.get(url).then((result) => result.data)
  },
  customerCareForm(formData) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/claimPoints/${pubId}`
    return $axios.post(url, formData).then((result) => {
      return result.data
    })
  },
  postFaqsForm(formData) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/comments/${pubId}`
    return $axios.post(url, formData).then((result) => {
      return result.data
    })
  },
  postPreferencesForm(formData) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/updatePreferences`
    return $axios.post(url, formData).then((result) => {
      return result.data
    })
  },
  getPreferencesForm() {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/getPreferencesWeb`
    return $axios.get(url).then((result) => result.data)
  },
  postProfileForm(formData) {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/updateProfile`
    return $axios.post(url, formData).then((result) => {
      return result.data
    })
  },
  getProfileForm() {
    const domain = this.getDomain()
    const url = `${domain}/loyalty-api/getProfileWeb`
    return $axios.get(url).then((result) => result.data)
  },
  getRegionForm(countryId) {
    const domain = this.getDomain()
    const url = `${domain}/oci-api/regions/${countryId}`
    return $axios.get(url).then((result) => result.data)
  },
  getDomain() {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    return domain === 'localhost' ? $axios.defaults.baseURL : `${protocol}//${domain}`
  },
  cancelLiveLocal(formData, type, ghaId) {
    const domain = this.getDomain()
    let url = ''
    if (type === 'experiences') {
      url = `${domain}/livelocal-api/cancelBookExperience/${ghaId}`
    } else if (type === 'localoffers') {
      url = `${domain}/livelocal-api/cancelBookLocalOffer/${ghaId}`
    }
    return $axios.post(url, formData).then((result) => {
      return result.data
    })
  }
})
